import { ApiTagTypes, OrganizationSettings, OrganizationSettingsResponse } from '../../types';
import { apiSlice } from '../api.services';

interface GetOrganizationSettingsParams {
  orgId?: string;
}

const enhancedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationSettings: builder.query<OrganizationSettings, GetOrganizationSettingsParams>({
      query: (params) => ({
        url: '/organization-settings',
        params,
      }),
      transformResponse: (response: OrganizationSettingsResponse) => response.data.settings,
      providesTags: [ApiTagTypes.ORGANIZATION_SETTINGS],
    }),
  }),
});

export const { useGetOrganizationSettingsQuery } = enhancedApiSlice;
